export type Preferences = {
  theme: Record<ActualizedThemeMode, UITheme>;
  themeMode: ThemeMode;
  tokenStyle: TokenStyle;
  boardBackground: BoardBackground;
};

export enum ThemeMode {
  Dark = "Dark",
  Light = "Light",
  System = "System",
}

export type ActualizedThemeMode = Exclude<ThemeMode, ThemeMode.System>;

export type PartialPreferences = Partial<{
  theme: Partial<Record<ActualizedThemeMode, UITheme>>;
  themeMode: ThemeMode;
  tokenStyle: TokenStyle;
  boardBackground: BoardBackground;
}>;

export type UITheme = DarkModeUITheme | LightModeUITheme;

// A theme that exists in both palette modes carries a mode suffix, because the two
// enums share the `UITheme` union and a `Record<UITheme, ...>` cannot hold the same
// string value twice. Mode-exclusive themes (Stadium, Turf, Whiteboard) need none.
export enum DarkModeUITheme {
  ClassicDark = "ClassicDark",
  SportyDark = "SportyDark",
  Stadium = "Stadium",
  ChalkTalkDark = "ChalkTalkDark",
  PlaybookPrintDark = "PlaybookPrintDark",
  BroadcastDark = "BroadcastDark",
}

export enum LightModeUITheme {
  ClassicLight = "ClassicLight",
  Turf = "Turf",
  Whiteboard = "Whiteboard",
  Notebook = "Notebook",
  ChalkTalkLight = "ChalkTalkLight",
  PlaybookPrintLight = "PlaybookPrintLight",
  BroadcastLight = "BroadcastLight",
}

export enum TokenStyle {
  Classic = "Classic",
  Gradient = "Gradient",
  Jersey = "Jersey",
}

export enum BoardBackground {
  Classic = "Classic",
  BlackAndWhite = "BlackAndWhite",
  Realistic = "Realistic",
}
